
<div ref="defineTab">
  <panel-block v-if="selectedObjectModelTrigger.can(ObjectModelTriggerCapability.labelable)" id="pn-name">
    <panel-item>
      <label :for="selectedObjectModelTrigger.idForProp('label')">Trigger Name</label>
      <expandable-textarea
        :id="selectedObjectModelTrigger.idForProp('label')"
        v-model="selectedObjectModelTrigger.label_title"
        placeholder="Enter Event name..."></expandable-textarea>
    </panel-item>
  </panel-block>
  <panel-block v-if="selectedObjectModelTrigger.can(ObjectModelTriggerCapability.triggerRunnableFor)">
    <panel-item>
      <label :for="selectedObjectModelTrigger.idForProp('trigger_runs_for_type')">
        Trigger runs for
      </label>
      <a-select
        :id="selectedObjectModelTrigger.idForProp('trigger_runs_for_type')"
        compress
        v-model="selectedObjectModelTrigger.trigger_runs_for_type"
        :options="objectModelTriggerRunsForOptions"
        @input="updateTriggerBasedOn"></a-select>
    </panel-item>
  </panel-block>
  <panel-block>
    <panel-item>
      <label :for="selectedObjectModelTrigger.idForProp('trigger_based_on_type')">
        Trigger based on
        <help-tooltip v-if="selectedObjectModelTrigger.is_published_time_trigger">changing this after publishing is currently not supported</help-tooltip>
      </label>
      <a-select
        :id="selectedObjectModelTrigger.idForProp('trigger_based_on_type')"
        compress
        v-model="selectedObjectModelTrigger.trigger_based_on_type"
        :disabled="selectedObjectModelTrigger.is_published_time_trigger"
        :options="objectModelTriggerBasedOnOptions"></a-select>
    </panel-item>
  </panel-block>

  <panel-block v-if="selectedObjectModelTrigger.trigger_based_on_type === ObjectModelTriggerBasedOnType.TimeBasedEvent">
    <panel-item>
      <conditional-wrapper
        :parent="selectedObjectModelTrigger"
        :field-definition="ObjectModelConditionalFields.TIME_TRIGGER_AVAILABLE"
        :has-otherwise-value="false"
        :can-add-rule="Object.keys(selectedObjectModelTrigger.time_trigger_conditional_rule_sets).length === 0"
        :validation-model="selectedObjectModelTrigger.parent"
        :validation-field-name="`triggerConditional-${selectedObjectModelTrigger.client_id}`"
      >
        <template #header>
          Conditional
          <help-tooltip>Please read the documentation on how this works.</help-tooltip>
        </template>

        <template #value="slotProps">
          <input
            type="hidden"
            v-model="slotProps.model[slotProps.fieldName]"
            value="true"
          >
        </template>
      </conditional-wrapper>
    </panel-item>

    <panel-item>
      <configure-relative-time-component
        id="first_trigger"
        v-model="selectedObjectModelTrigger.first_trigger"
        prop_key="first_trigger"
        :model="selectedObjectModelTrigger"
        full-width
        compress
        :unitOptions="DurationAndTimeHelper.durationUnitOptions"
        :options="startDateAndTimeOptions">
        <template>
          Start date & time
        </template>
        <help-tooltip>Please read the documentation on how this works.</help-tooltip>
      </configure-relative-time-component>
    </panel-item>

    <panel-item>
      <label :for="selectedObjectModelTrigger.idForProp('occurs_at_interval')">Repeat</label>
      <a-select
        :id="selectedObjectModelTrigger.idForProp('occurs_at_interval')"
        compress
        v-model="occursAtInterval"
        :options="objectModelRepeatOptions"
        @input="updateInterval"></a-select>

      <template v-if="selectedObjectModelTrigger.occurs_at_interval">
        <configure-interval
          :interval="selectedObjectModelTrigger.interval"
          :occurs_at_interval="selectedObjectModelTrigger.occurs_at_interval"
          :custom_interval="selectedObjectModelTrigger.custom_interval">
        </configure-interval>
      </template>
    </panel-item>

  </panel-block>

  <panel-block  v-if="selectedObjectModelTrigger.trigger_based_on_type === ObjectModelTriggerBasedOnType.ObjectModelProperty">
    <conditional-wrapper
      :parent="selectedObjectModelTrigger"
      :field-definition="ObjectModelConditionalFields.TRIGGER_AVAILABLE"
      :has-otherwise-value="false"
      :conditional-rule-options="conditionalRuleOptions"
      :can-add-rule="Object.keys(selectedObjectModelTrigger.trigger_conditional_rule_sets).length === 0"
      :validation-model="selectedObjectModelTrigger.parent"
      :validation-field-name="`triggerConditional-${selectedObjectModelTrigger.client_id}`"
    >
      <template #header>
        Triggered
      </template>
      <template #value="slotProps">
        <input type="hidden"
               v-model="slotProps.model[slotProps.fieldName]"
               value="true">
      </template>
    </conditional-wrapper>
  </panel-block>
</div>
